module.exports = __webpack_public_path__ + "static/media/test-product-by-brand-1.344bc2f4.png";